import React from "react";
import AddRemitoForm from "./AddRemitoForm";
import "../css/admin.css";

const AddRemito = ({ show, setShow }) => {
  const handleToggle = () => setShow((s) => !s);

  return (
    <>
      <div>
        <button className="btn btn-dark" onClick={handleToggle}>
          {show ? "Ocultar Form" : "Agregar Remito"}
        </button>
        <hr />
      </div>

      {/* 👇 SIEMPRE montado; el modal se abre/cierra con show */}
      <AddRemitoForm
        show={show}
        onClose={() => setShow(false)}
      />
    </>
  );
};

export default AddRemito;
